import { Button } from "components/ui/Button";
import { Modal } from "./compound/Modal";

export type ButtonVariant =
  | "default"
  | "primary"
  | "secondary"
  | "black"
  | "white"
  | "outline"
  | "disabled"
  | "secondaryPrimary"
  | "secondaryError"
  | "secondaryLight"
  | "error"
  | "primaryWhite";

interface CommonModalProps {
  open: boolean;
  onClose?: () => void;
  title: string;
  subTit1?: string;
  subTit2?: string;

  leftBtnTxt?: string;
  leftBtnVariant?: ButtonVariant;
  leftBtnOnClick?: () => void;
  rightBtnTxt: string;
  rightBtnVariant?: ButtonVariant;
  rightBtnOnClick?: () => void;
}

export const AlertModal = ({
  open,
  onClose,
  title,
  subTit1,
  subTit2,
  leftBtnTxt,
  leftBtnVariant,
  leftBtnOnClick,
  rightBtnTxt,
  rightBtnVariant,
  rightBtnOnClick,
}: CommonModalProps) => {
  if (!open) {
    return null;
  }

  return (
    open && (
      <Modal.AlertBackground>
        <Modal.AlertHeader>{title}</Modal.AlertHeader>
        <Modal.AlertContent>
          {subTit1 && <div>{subTit1}</div>}
          {subTit2 && <div>{subTit2}</div>}
        </Modal.AlertContent>
        <Modal.AlertBottom>
          {leftBtnTxt && (
            <Button variant={leftBtnVariant} size="mmd" onClick={leftBtnOnClick}>
              {leftBtnTxt}
            </Button>
          )}
          <Button variant={rightBtnVariant} size="mmd" onClick={rightBtnOnClick}>
            {rightBtnTxt}
          </Button>
        </Modal.AlertBottom>
      </Modal.AlertBackground>
    )
  );
};
